<div class="flex flex-col">
  <label [tailLabel]="i" i18n="@@custom_google_font">Custom Google Font</label>
  <input tailInput #i="input" [(ngModel)]="googleFont" placeholder="Roboto:wght@300;400;700" />
  <p tailHint i18n="@@empty_google_font">Leave empty to use standard fonts.</p>
</div>
<div class="flex flex-col pt-2">
  <label [tailLabel]="s" *ngIf="!googleFont" i18n="@@standard_font">Standard Font</label>
  <label [tailLabel]="s" *ngIf="googleFont" i18n="@@fallback_font">Fallback Font</label>
  <select tailInput #s="input" [(ngModel)]="family" class="appearance-none">
    <option *ngFor="let font of standardFonts" [value]="font">{{font}}</option>
  </select>
  <p tailHint *ngIf="googleFont" i18n="@@fallback_font_description">
    Fallback font is used in case custom font is not supported.
  </p>
</div>

<div class="grid grid-cols-3 gap-2 pt-2">
  <div class="flex flex-col">
    <label [tailLabel]="fs" i18n="@@font_size">Size</label>
    <input tailInput #fs="input" [(ngModel)]="value.size" type="number" />
  </div>
  <div class="flex flex-col">
    <label [tailLabel]="w" i18n="@@font_weight">Weight</label>
    <select tailInput #w="input" [(ngModel)]="weight" class="appearance-none">
      <option *ngFor="let weight of weights" [value]="weight">{{weight}}</option>
    </select>
  </div>
  <div class="flex flex-col">
    <label [tailLabel]="fst" i18n="@@font_style">Style</label>
    <select tailInput #fst="input" [(ngModel)]="value.style" class="appearance-none">
      <option *ngFor="let style of styles" [value]="style">{{getStyleLabel(style)}}</option>
    </select>
  </div>
</div>
